<template>
  <article :style="{ '--de-padding': chipSize }">
    <Space pheight="150px" />
    <div class="Margin">
      <div class="Grid">
        <div class="TitleContainer">
          <Title>{{ $t('arriving_station.header') }}</Title>
        </div>
        <div class="Container">
          <div class="Header">{{ $t('arriving_station.box_header') }}</div>
          <div class="Description">
            {{ $t('arriving_station.description') }}
          </div>
        </div>
        <section class="StatusBox">
          <Chips :dispatch="dispatch" :poleState="poleState" />
        </section>
        <PoleImage :imagePng="imagePng" :imageWebp="imageWebp" />
        <div class="Payment">
          <PaymentMethods
            :isMobile="isMobile"
            :paymentMethods="paymentMethods"
            :dispatch="dispatch"
          />
        </div>
      </div>
    </div>
  </article>
</template>
<script>
import PaymentMethods from '../PaymentMethods/PaymentMethods.vue';
import i18n from '../../../i18n';
import { entity } from '../../../../region.json';
import PoleImage from './PoleImage.vue';
import Space from '../../../layout/space';
import Chips from './Chips.vue';
import Title from '../Title.vue';
import matchEntities from '../../../shared/entityHelpers';

const icon1 = require('../../../assets/qwello-app-ic.svg');
const icon2 = require('../../../assets/contactless-ic.svg');
const icon3 = require('../../../assets/roaming-ic.svg');

const redWebp = require('../../../assets/experiencePage/pole-red.webp');
const yellowWebp = require('../../../assets/experiencePage/pole-yellow.webp');
const blueWebp = require('../../../assets/experiencePage/pole-blue.webp');
const greenWebp = require('../../../assets/experiencePage/pole.webp');
const poland = require('../../../assets/experiencePage/status-light-POLAND.webp');

const redPng = require('../../../assets/experiencePage/pole-red.jpg');
const yellowPng = require('../../../assets/experiencePage/pole-yellow.jpg');
const bluePng = require('../../../assets/experiencePage/pole-blue.jpg');
const greenPng = require('../../../assets/experiencePage/pole-green.jpg');

function getPoleStates(entityName) {
  if (['POLAND', 'NETHERLANDS'].includes(entityName))
    return [
      {
        active: true,
        bgActive: '#7DCC93',
        bg: 'none',
        text: 'arriving_station.status_available',
        className: 'Available',
        type: 'solid',
        color: 'white',
        colorActive: '#2B4047',
      },
      {
        active: false,
        bgActive: '#2299FF',
        bg: 'none',
        text: 'arriving_station.status_charging',
        className: 'Charging',
        type: 'solid',
        color: 'white',
        colorActive: '#2B4047',
      },
      {
        active: false,
        bgActive: '#F15C5E',
        bg: 'none',
        text: 'arriving_station.status_unavailable',
        className: 'Unavailable',
        type: 'solid',
        color: 'white',
        colorActive: '#2B4047',
      },
    ];

  return [
    {
      active: true,
      bgActive: '#7DCC93',
      bg: 'none',
      text: 'arriving_station.status_available',
      className: 'Available',
      type: 'solid',
      color: 'white',
      colorActive: '#2B4047',
    },
    {
      active: false,
      bgActive: '#FFDF22',
      bg: 'none',
      text: 'arriving_station.status_reserved',
      className: 'Reserved',
      type: 'solid',
      color: 'white',
      colorActive: '#2B4047',
    },
    {
      active: false,
      bgActive: '#2299FF',
      bg: 'none',
      text: 'arriving_station.status_charging',
      className: 'Charging',
      type: 'solid',
      color: 'white',
      colorActive: '#2B4047',
    },
    {
      active: false,
      bgActive: '#F15C5E',
      bg: 'none',
      text: 'arriving_station.status_unavailable',
      className: 'Unavailable',
      type: 'solid',
      color: 'white',
      colorActive: '#2B4047',
    },
  ];
}
function getPaymentMethods() {
  const paymentMethods = [
    { text: 'payment_methods.in_app.title', active: true, icon: icon1 },
    {
      text: 'payment_methods.contactless.title',
      active: false,
      icon: icon2,
      hide: matchEntities(['POLAND', 'NETHERLANDS']),
    },
    {
      text: 'payment_methods.charging_card.title',
      active: false,
      icon: icon3,
    },
  ];
  return paymentMethods;
}
export default {
  components: { PaymentMethods, Chips, Space, Title, PoleImage },
  data() {
    return {
      redWebp,
      entity,
      yellowWebp,
      greenWebp,
      redPng,
      yellowPng,
      bluePng,
      blueWebp,
      greenPng,
      imagePng: matchEntities(['POLAND', 'NETHERLANDS']) ? poland : greenPng,
      imageWebp: matchEntities(['POLAND', 'NETHERLANDS']) ? poland : greenWebp,
      poland,
      isMobile: null,
      chipSize: null,
      poleState: getPoleStates(entity),
      paymentMethods: getPaymentMethods(),
    };
  },
  created() {
    this.isMobile = window.innerWidth <= 768;
    // change chip width if user lang is 'de'
    this.germanStyles();
  },

  methods: {
    poleIndex(idx) {
      if (matchEntities(['POLAND', 'NETHERLANDS'])) {
        this.imagePng = this.poland;
        this.imageWebp = this.poland;
        return;
      }

      if (idx === 2) {
        this.imageWebp = this.blueWebp;
        this.imagePng = this.bluePng;
      }
      if (idx === 1) {
        this.imageWebp = this.yellowWebp;
        this.imagePng = this.yellowPng;
      }
      if (idx === 3) {
        this.imageWebp = this.redWebp;
        this.imagePng = this.redPng;
      }
      if (idx === 0) {
        this.imageWebp = this.greenWebp;
        this.imagePng = this.greenPng;
      }
    },
    dispatch(action) {
      switch (action.type) {
        case 'chip':
          if (this.poleState[action.idx].active === true) {
            return;
          }
          this.poleIndex(action.idx);
          this.poleState = this.handleChipClick(action.idx);
          break;
        case 'payment_btn':
          this.paymentMethods = this.handlePaymentClick(action.idx);
          break;
        default:
          throw new Error('Invalid dispatch');
      }
    },
    handleChipClick(idx) {
      return this.poleState.map((chip, index) => {
        if (idx === index) {
          return { ...chip, active: true };
        }

        return { ...chip, active: false };
      });
    },
    handlePaymentClick(index) {
      return this.paymentMethods.map((elem, idx) => {
        if (idx === index) {
          return { ...elem, active: true };
        }
        return { ...elem, active: false };
      });
    },
    onResize() {
      if (window.innerWidth <= 768 && !this.isMobile) {
        this.isMobile = true;
      } else if (window.innerWidth > 768 && this.isMobile) {
        this.isMobile = false;
      }
      // change chip width if user lang is 'de'
      this.germanStyles();
    },
    germanStyles() {
      if (i18n.locale === 'de') {
        if (window.innerWidth > 420) {
          this.chipSize = '12%';
        } else {
          this.chipSize = '15%';
        }
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style scoped>
.Margin {
  /* margin: 0 30px; */
}
.Grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-auto-rows: auto;
  --chip-width: 100px;
  --chip-border-radius: 20px;
  --chip-active-bg: #7dcc93;
  --description-f-size: 14px;
  --header-f-size: 18px;
  --text-margin: 1.9em;
  --text-width: 100%;
  --outside-margin: 30px;
  --status-width: 45%;
}
.TitleContainer {
  grid-row: 1;
  grid-column: 1;
  margin-bottom: var(--text-margin);
  margin-right: var(--outside-margin);
  margin-left: var(--outside-margin);
}

.Container {
  grid-row: 2;
  grid-column: 1;
  align-self: center;
  margin-right: var(--outside-margin);
  margin-left: var(--outside-margin);
  margin-bottom: calc(var(--text-margin) * 1.3);
}
.Header {
  color: #2b4047;
  font-size: var(--header-f-size);
  max-width: var(--text-width);
  font-weight: bold;
  line-height: 1.4;
  margin-bottom: 1em;
}
.Description {
  font-size: var(--description-f-size);
  max-width: var(--text-width);
  color: #2b4047;
}
.StatusBox {
  grid-row: 3;
  grid-column: 1;
  height: 250px;
  width: var(--status-width);
  align-self: center;
  justify-self: flex-start;
  background: #2b4047;
  border-radius: 12px 0px 0px 12px;
  box-shadow: 0px 3px 6px #00000029;
  /* min-height: 385px; */
}
.ImageWrapper {
  grid-column: 1;
  grid-row: 3;
  width: 55%;
  /* height: 350px; */
  justify-self: flex-end;
  /* max-width: 210px; */
  animation: movingImage 0.3s linear;
}
.PoleImage {
  display: block;
  width: 100% !important;
  object-fit: cover;
  height: 100%;
}
.Payment {
  grid-row: 4;
  grid-column: 1;
  max-width: 100%;
}
@media (min-width: 400px) {
  .Grid {
    --outside-margin: 36px;
  }
}
@media (min-width: 768px) {
  .Margin {
    margin: 0 0 0 40px;
  }
  .Grid {
    --header-f-size: 20px;
    grid-template-columns: 2fr minmax(293px, 1fr);
    grid-template-rows: 150px auto 2fr;
    grid-auto-rows: auto;
    --chip-width: 108px;
    --chip-border-radius: 22px;
    --text-margin: 0px;
    --text-width: 50%;
    --outside-margin: 0px;
    --status-width: 190px;
    --status-height: 200px;
  }
  .Container {
    grid-row: 2;
    grid-column: 1;
    align-self: center;
  }
  .Header {
    color: #2b4047;
    font-size: var(--header-f-size);
    max-width: 50%;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 1em;
  }
  .Description {
    font-size: var(--description-f-size);
    max-width: 50%;
  }
  .StatusBox {
    grid-row: 2;
    grid-column: 1;
    height: 100%;
    background: #2b4047;
    justify-self: flex-end;
    border-radius: 12px 0px 0px 12px;
    box-shadow: 0px 3px 6px #00000029;
    min-height: var(--status-height);
    max-height: var(--status-height);
    max-width: var(--status-width);
  }
  .ImageWrapper {
    grid-column: 2;
    grid-row: 1 / -1;
    width: 100%;
  }
  .PoleImage {
    display: block;
    height: auto;
    width: auto;
  }
  .Payment {
    margin-top: 20vw;
    grid-row: 3;
    grid-column: 1 / -1;
    max-width: 100%;
    margin-right: 40px;
  }
}
@media (min-width: 1024px) {
  .Margin {
    margin: 0 0 0 60px;
  }
  .Grid {
    --status-width: 190px;
  }
  .Payment {
    margin-top: 0;
    grid-row: 3;
    grid-column: 1;
    max-width: 100%;
    margin-right: 0;
  }
}
@media (min-width: 1280px) {
  .Grid {
    --description-f-size: 16px;
  }
}
@media (min-width: 1400px) {
  .Grid {
    --header-f-size: 30px;
    --status-width: 385px;
    --status-height: 385px;
    --chip-width: 180px;
    --chip-border-radius: 27px;
  }
  .Margin {
    margin: 0 60px;
  }
}
@media (min-width: 1600px) {
  .Margin {
    margin: 0 140px;
  }
  .Grid {
    --description-f-size: 20px;
  }
}
@media (min-width: 1800px) {
  .Grid {
    --header-f-size: 40px;
  }
  .ImageWrapper {
    width: 100%;
  }
}
</style>
